/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type DocsCreateCopyCreateRequest = {} | null | undefined;
export type DocsCreateCopyCreateResponse = any;

export type DocsCreateCopyCreateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * POST /dmx-server/docs/{id}/create_copy/
 *
 * ```yaml
 * operationId: docs_create_copy_create
 * description: >-
 *   You can order docs using GET param ordering_state
 *
 *   example:
 *
 *   http://localhost/dmx-server/docs_reduced/?ordering_state=CANCELED,SUBMITTED,REJECTED,ACCEPTED
 *
 *   At first all CANCELED docs, then all with state SUBMITTED, then REJECTED, etc.
 * tags:
 *   - docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const docsCreateCopyCreateOperation = ({ id, ...rest }: DocsCreateCopyCreateQuery) =>
  ({
    method: 'POST',
    path: `/dmx-server/docs/${id}/create_copy/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/docs/{id}/create_copy/' };
  };

/**
 * POST /dmx-server/docs/{id}/create_copy/
 *
 * ```yaml
 * operationId: docs_create_copy_create
 * description: >-
 *   You can order docs using GET param ordering_state
 *
 *   example:
 *
 *   http://localhost/dmx-server/docs_reduced/?ordering_state=CANCELED,SUBMITTED,REJECTED,ACCEPTED
 *
 *   At first all CANCELED docs, then all with state SUBMITTED, then REJECTED, etc.
 * tags:
 *   - docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const docsCreateCopyCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: DocsCreateCopyCreateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = docsCreateCopyCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
